import { toast } from "react-toastify";
import style from "./style.module.scss";

export const validateForm = __container => {
  const _input_nodes = __container.querySelectorAll("[data-required]");
  const _inputs = [..._input_nodes];

  let _errors = [];
  for (const __input of _inputs) {
    __input.removeAttribute("data-required-error");
    if (
      __input.getAttribute("data-required") === "true" &&
      (__input.getAttribute("data-required-valid") === "false" || __input.getAttribute("data-has-error") === "true")
    ) {
      _errors.push(__input);
      setTimeout(() => {
        __input.setAttribute("data-required-error", "empty");
      }, 200);
    }
  }
  if (_errors.length > 0) {
    console.log("_error", _errors);
    toast.error("Preencha os campos obrigatórios com valores válidos.", {
      toastId: "required_fields",
    });
    const _is_modal = __container.classList.contains("modal-dialog");
    const _target_container = _is_modal ? __container.parentNode : window;
    const _offset = _errors[0].offsetTop + (!_is_modal ? -30 : 0);
    _target_container.scrollTo({
      top: _offset,
      behavior: "instant",
    });

    return false;
  }
  return true;
};

export const validateStyle = style;
